<template>
  <div class="MemberHeader">
    <el-dialog
      :visible.sync="show"
      title="CA盖章环境监测异常"
      width="700px"
      class="dialog-wrap form-module"
      :close-on-press-escape="false"
      :show-close="true"
      :center="true"
      :close-on-click-modal="false"
    >
      <div style="padding-left: 0.625rem; padding-top: 0.9375rem" class="warn_content">
        <p style="font-size: medium; padding-bottom: 15px">系统监测到您当前电脑的CA盖章环境异常，将无法完成报价，请按照如下步骤指引操作：</p>
        <p style="font-size: medium; padding-bottom: 15px">
          （1）、在浏览器地址栏输入：chrome://flags/#local-network-access-check，将“Local Network Access Check”设置为“Disabled”后重启浏览器
        </p>
        <p style="font-size: medium; padding-bottom: 15px">（2）、点击下面按钮下载CA环境安装包，在电脑上重新安装CA盖章软件。</p>
        <p style="font-size: medium; padding-bottom: 15px">完成上述操作后重启浏览器在进入报价页面。</p>

        <div style="padding-top: 1rem; text-align: center">
          <el-button class="apply_btn" type="primary" @click="downloadTemplate()"> 下载CA环境安装包</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="show2"
      title="CA盖章环境监测异常"
      width="700px"
      class="dialog-wrap form-module"
      :close-on-press-escape="false"
      :show-close="true"
      :center="true"
      :close-on-click-modal="false"
    >
      <div style="padding-left: 0.625rem; padding-top: 0.9375rem" class="warn_content">
        <p style="font-size: medium; padding-bottom: 15px">系统检测到您当前使用的浏览器不是“谷歌浏览器”或者浏览器版本过低，可能会导致报价失败；</p>
        <p style="font-size: medium; padding-bottom: 15px">
          请前往谷歌浏览器官网<a href="https://www.google.cn/chrome/" target="_blank">https://www.google.cn/chrome/</a>
          获取最新版本的谷歌浏览器后重试！
        </p>
      </div>
    </el-dialog>
    <div class="logo"><img src="@/assets/img/logo2.png" alt="" /></div>
    <div class="text">
      <router-link target="_blank" class="blank" :to="{ path: '/' }">门户首页</router-link>
      <span>|</span>
      <span @click.stop="changePwd">修改密码</span>
      <span>|</span>

      <span @click.stop="quit()">注销</span>
      <span>|</span>
      <span @click.stop="checkCA">检测CA环境</span>
    </div>
  </div>
</template>
<script>
import { getNativeChromeInfo } from '@/assets/js/browser.js'
export default {
  data() {
    return {
      show: false,
      show2: false
    }
  },
  methods: {
    // 手动触发检测
    checkCA() {
      const info = getNativeChromeInfo()
      console.log('浏览器：', info.isChrome)
      console.log('版本：', info.version)
      if (!info.isChrome || Number(info.version) < 142) {
        this.show2 = true
      } else {
        // 发一个 HEAD 请求试探是否能连通
        fetch('http://127.0.0.1:21051/PDFClient/viewer.html', {
          method: 'GET', // 关键
          mode: 'cors' // 跨域不报错
        })
          .then((res) => {
            console.log(res)
            if (res.statusText == 'OK') {
              this.$message.success('您电脑的环境正常，可正常报价！')
            } else {
              this.show = true
            }
          })
          .catch((err) => {
            console.log(err)
            this.show = true
          })
      }
    },
    changePwd() {
      this.$router.push({
        path: '/ChangePassword'
      })
    },
    quit() {
      window.localStorage.removeItem('loginToken')

      this.$router.push({ path: '/' })
    },
    downloadTemplate() {
      var templatefilePath = '~/App_Data/Template/CA环境安装包.zip'
      var fileName = 'CA环境安装包'
      var url = 'SupplierLogin/DownloadTemplate?TemplatefilePath=' + templatefilePath + '&FileName=' + fileName
      this.downloadfile(this.baseURL + url)
    }
  }
}
</script>

<style lang="scss" scoped>
.MemberHeader {
  display: flex;
  align-items: center;
  height: 60px;
  padding: 0 20px;
  background: #0660a2;
  .logo {
    flex: 1;
  }
  .text {
    color: #cccccc;
    a {
      color: #cccccc;
      text-decoration: none;
    }
    cursor: pointer;
    span {
      margin: 0 10px;
    }
  }
}
</style>
